<form [formGroup]="searchForm">
  <glxy-form-field>
    <glxy-label>
      {{ 'SENDER_CHOOSER.SENDER.PLACEHOLDER' | translate }}
    </glxy-label>
    <mat-select formControlName="senderType">
      <!-- Leaving these untranslated to preserve integrity with data model -->
      <mat-option [value]="partnerSenderType">Partner</mat-option>
      <mat-option [value]="businessSenderType">Business</mat-option>
    </mat-select>
  </glxy-form-field>

  <glxy-form-field>
    <glxy-label>{{ idLabel$ | async }}</glxy-label>
    <input type="text" matInput formControlName="senderId" autocomplete="off" />
  </glxy-form-field>
</form>
